import axios from 'axios';
import {authentication} from '../Authentication';

// Add a request interceptor
axios.interceptors.request.use(
  async function (config) {
    if (localStorage.getItem('user')) {
      config.headers.Authorization = 'Bearer ' + localStorage.getItem('user');
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);

const myInterceptor = axios.interceptors.request.use(function () {
  /*...*/
});
axios.interceptors.request.eject(myInterceptor);

export default axios;

const ignoreHttp = ['localhost', ''];
const url = new URL(window.location.href);
url.searchParams.delete('qr');
url.search = '';
const cleanUrl = url.toString().replace('react/solicitud', '');

export const UrlFull = ignoreHttp.includes(window.location.hostname)
  ? process.env.REACT_APP_URL_USER
  : cleanUrl;
